<template>
  <div>
    <div class="card-filter-section mt-0 d-flex align-items-center justify-content-between">
      <p class="task-timesheet m-0">
        External Users List
      </p>
      <div class="d-flex align-items-center">
        <table-button
          v-b-toggle.addSystemEmployee
          btn-name="Add External User"
          class="mr-1"
        />
        <Help
          v-show="$store.state.app.userManualList"
          code="ANE"
        />
      </div>
    </div>

    <!-- Filter start -->
    <div class="card-filter-section">
      <div class="d-flex align-items-center flex-wrap justify-content-between">
        <div class="d-flex align-items-center justify-content-start flex-wrap">
          <p class="filter-title">
            Filters:
          </p>

          <div class="">
            <custom-dropdown
              v-model="is_active"
              :options="isActiveList"
              :search-box="false"
              :hide-close="true"
              label="Active"
              icon="EditIcon"
            />
          </div>
          <!-- <div class="">
            <custom-dropdown
              v-model="userStatus"
              :search-box="false"
              :options="statusList"
              :hide-close="true"
              label="Status"
              icon="EditIcon"
            />
          </div> -->
          <div class="">
            <custom-dropdown
              v-model="role"
              :search-box="false"
              :options="roleList"
              label="Role"
              icon="EditIcon"
            />
          </div>
          <div class="">
            <custom-dropdown
              v-model="manage_by"
              :options="manage_by_users"
              label="Managed by"
              icon="EditIcon"
            />
          </div>
          <div class="">
            <custom-dropdown
              v-model="reporting_to"
              :options="reporting_to_users"
              label="Reporting to"
              icon="EditIcon"
            />
          </div>
          <!-- <div>
            <custom-dropdown
              v-model="designation_id"
              :options="designations"
              label="Designation"
              icon="EditIcon"
            />
          </div> -->
          <div class="">
            <custom-dropdown
              v-model="shift_id"
              :options="shiftOptions"
              label="Shift"
              icon="EditIcon"
            />
          </div>
          <option-drop-down v-model="perPage" />
        </div>

        <div class="d-flex align-items-center">
          <b-input-group class="input-group-merge search-project filter-search-input">
            <b-form-input
              v-model="debouncedSearch"
              placeholder="Search by Employee Name"
            />
            <b-input-group-append is-text>
              <feather-icon
                v-if="debouncedSearch"
                icon="XIcon"
                @click="debouncedSearch = null, search = null"
              />
              <feather-icon icon="SearchIcon" />
            </b-input-group-append>
          </b-input-group>

          <div class="ml-1 d-flex align-items-center">
            <b-button
              v-if="selectedEmployees.length > 0"
              v-b-modal.bulkAssignShiftModal
              variant="primary"
              class=" mr-1"
              style="padding: 6px 11px; border-radius: 5px;"
            >
              Bulk Assign Shift ({{ selectedEmployees.length }})
            </b-button>
            <button
              class="apply-filter filterRedesign mr-1"
              @click="getUserData()"
            >
              Apply Filter
            </button>
            <button
              class="apply-filter-clear filterRedesign"
              @click="clearFilter()"
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Filter End -->

    <div class="user-table table">
      <table-loader
        v-if="loader"
        :fields="fields_userList"
      />
      <b-row v-else>
        <b-col cols="12">
          <b-table
            id="table"
            responsive
            :items="items"
            :fields="fields_userList"
            show-empty
            class="scrollable-element user-table-items approvel-table tableDesigns mastertblColor"
          >
            <template #head(selected)>
              <b-form-checkbox
                v-model="selectAll"
                :indeterminate="isIndeterminate"
                class="table-checkbox"
                @change="toggleSelectAll"
              />
            </template>
            <template #cell(selected)="data">
              <b-form-checkbox
                v-model="selectedEmployees"
                :value="data.item.id"
                class="table-checkbox"
                @change="onSelectionChange"
              />
            </template>
            <template #cell(name)="data">
              <div class="media">
                <div class="media-aside align-items-center">
                  <b-avatar
                    size="md"
                    :src="data.item.picture"
                    :text="data.item.full_name | avatarText"
                    :variant="randomVariant(1, items.length)"
                  />
                </div>
                <div class="media-body">
                  <p
                    class="d-block user-emp-name"
                    :style="{ color: '#' + data.item.color }"
                  >
                    {{ data.item.name }} {{ data.item.last_name }}
                    <img
                      v-if="data.item.status == 'invited'"
                      v-b-tooltip.hover.top="'Pending'"
                      src="../../assets/images/icons/Pending.svg"
                    >
                  </p>
                  <small class="user-emp-status">{{
                    data.item.role === "SA"
                      ? "Super Admin"
                      : data.item.role === "EMP"
                        ? "Employee"
                        : data.item.role === "HR"
                          ? "Human resources"
                          : "Manager"
                  }}</small>
                </div>
              </div>
            </template>

            <template #cell(primary_skills)="data">
              <span
                v-for="(skill, sindex) in data.item.primary"
                :key="sindex"
                class="badge text-capitalize badge-light-success badge-pill"
                style="margin-right: 5px"
              >
                {{ skill.name }}
              </span>
            </template>

            <template #cell(secondary_skill)="data">
              <span
                v-for="(skill, sindex) in data.item.secondary"
                :key="sindex"
                class="badge text-capitalize badge-light-success badge-pill"
                style="margin-right: 5px"
              >
                {{ skill.name }}
              </span>
            </template>

            <template #cell(is_active_date)="data">
              {{ data.item.inactive_date }}
            </template>

            <template #cell(status)="data">
              <b-badge
                v-if="data.item.value === 'rejected'"
                variant="light-danger"
              >
                Rejected
              </b-badge>
              <b-badge
                v-else-if="data.value === 'invited'"
                variant="light-success"
              >
                Invited
              </b-badge>
              <b-badge
                v-else-if="data.value === 'joined'"
                variant="light-info"
              >
                Joined
              </b-badge>
            </template>

            <template #cell(inactive_date)="data">
              <span v-if="data.item.inactive_date">
                {{ data.item.inactive_date | formatDateDDMMYYYY }}
              </span>
              <span v-else>-</span>
            </template>

            <template #cell(shift)="data">
              <span v-if="data.item.shift && data.item.shift.name">{{ data.item.shift.name }}</span>
              <span v-else class="text-muted">-</span>
            </template>

            <template #cell(working_mode)="data">
              <span v-if="data.item.working_mode" class="text-capitalize">{{ data.item.working_mode }}</span>
              <span v-else class="text-muted">-</span>
            </template>

            <template #cell(is_active)="data">
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  :checked="!!data.item.is_active"
                  class="custom-control-success"
                  switch
                  :disabled="statusLoader === data.item.id"
                  @change="toggleStatus(data.item)"
                />
                <span
                  class="ml-50"
                  :class="data.item.is_active ? 'text-success' : 'text-danger'"
                  style="font-size:12px; font-weight:600;"
                >
                </span>
              </div>
            </template>

            <template #cell(action)="data">
              <span class="d-flex">
                <feather-icon
                  v-b-tooltip.hover.top="'Edit'"
                  icon="EditIcon"
                  class="mr-1 text-dark"
                  size="18"
                  @click="edit(data.item)"
                />
                <feather-icon
                  v-if="data.item.status == 'invited'"
                  v-b-tooltip.hover.top="'Send'"
                  icon="SendIcon"
                  class="text-primary cursor-pointer"
                  size="18"
                  @click="sendInvitationMail(data.item.id)"
                />
              </span>
            </template>
          </b-table>

          <img
            v-if="totalCount == 0"
            src="@/assets/images/nodatafound/nodata.svg"
            alt="no-data"
            class="no-data-img"
          >
        </b-col>
      </b-row>

      <!-- pagination -->
      <Pagination
        v-if="totalCount > 0 && !loader"
        :current-page="currentPage"
        :per-page="perPage"
        :total-count="totalCount"
        @currentPage="currentPage = $event"
      />

      <!-- Add / Edit system employee sidebar -->
      <system-employee-form
        ref="systemEmployeeForm"
        @employeeCreated="getUserData"
      />

      <!-- Bulk Assign Shift Modal -->
      <b-modal
        id="bulkAssignShiftModal"
        title="Bulk Assign Shift"
        centered
        @show="resetModal"
      >
        <div>
          <p class="mb-1">
            Assign shift to <strong>{{ selectedEmployees.length }}</strong> selected employee(s).
          </p>

          <b-form-group label="Select Shift" label-for="bulk-shift-select">
            <v-select
              id="bulk-shift-select"
              v-model="modalShiftId"
              :options="shiftOptions"
              :reduce="s => s.value"
              label="label"
              placeholder="Select Shift (or leave empty to remove shift)"
            />
          </b-form-group>
        </div>

        <template #modal-footer>
          <div class="d-flex justify-content-start w-50">
            <b-button
              variant="outline-secondary"
              class="mr-1"
              style="padding: 8px 30px; font-weight: 600;"
              @click="$bvModal.hide('bulkAssignShiftModal')"
            >
              Close
            </b-button>
            <b-button
              variant="primary"
              style="padding: 8px 30px; font-weight: 600;"
              :disabled="!modalShiftId"
              @click="submitBulkAssign"
            >
              Assign
            </b-button>
          </div>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import AddNewEmployeeMixin from '@/mixin/masterSetting/AddNewEmployee/index'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
  },
  mixins: [AddNewEmployeeMixin],
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables/_variables.scss";

@import "../../assets/scss/component-css/addNewEmployee.scss";
</style>
